import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from '../../environments/environment';
import { StorageService } from "./storage/storageService";
import { Logging } from "./logging";

@Injectable({
    providedIn: 'root'
})
export class GatewayAPIService {

    private API_URL = environment.apiUrl;
    private GATEWAY_URL = environment.gatewayUrl;
    private SET_ROOT  = environment.setRoot;

    //private AUTH_HEADER: string | null = null;

    private redirectingToSuiteSignIn: boolean = false;
    private authFailed: boolean = false;


    constructor(private storage:StorageService
    ) {

    }

    public getDefaultHeaders(): HttpHeaders {
        return new HttpHeaders({ 'Content-Type': 'application/json' });
    }

    public getMultipartHeaders(): HttpHeaders {
        // When sending multi-part requests, we have to let the browser
        // set the Content-type or else we'll be overriding the boundary
        // param that's needed on the service side to parse the request
        return new HttpHeaders({  });
    }

    public getPDFHeaders(): HttpHeaders {
        return new HttpHeaders({ 'Content-Type': 'application/pdf', 'Accept': 'application/pdf' });
    }

    public redirectToSuiteSignIn() {
        if (this.redirectingToSuiteSignIn) {
            return;
        }
        this.redirectingToSuiteSignIn = true;
        window.location.href = environment.suiteUrl + "/sign-in";
    }

    public async apiCallGateway(path:string,
        method: string,
        headers: HttpHeaders,
        params: Record<string, any> | null,
        data: unknown,
        options: any = { setRoot: true, authenticate: true, updateAuthHeader: false })
    {
        return this._apiCall(path, method, headers, params, data, options, this.GATEWAY_URL);
    }

    public async apiCallSane(path:string,
        method: string,
        headers: HttpHeaders,
        params: Record<string, any> | null,
        data: unknown,
        options: any = { setRoot: true, authenticate: true, updateAuthHeader: false })
    {
        return this._apiCall(path, method, headers, params, data, options, this.API_URL);
    }

    async _apiCall(path:string,
        method: string,
        headers: HttpHeaders,
        params: Record<string, any> | null,
        data: unknown,
        options: any = { setRoot: true, authenticate: true, updateAuthHeader: false }, uriBase:string)
    {
        //Logging.verbose(method + "ing to " + uriBase + path) //Removing the " with data " + JSON.stringify(data) to avoid logging sensitive data

        //TODO (jacob): this is hacky but I'm in a rush
        if (options == null) 
            options = {};

        if (options.setRoot == null)
            options.setRoot = true;
        if (options.authenticate == null)
            options.authenticate = true;
        if (options.updateAuthHeader == null)
            options.updateAuthHeader = false;

        if (params != null) {
            const tmp = new URLSearchParams();
            for (const key in params as any)
                tmp.append(key,params[key]);

            path = `${path}?${tmp.toString()}`;
        }

        const url = ((path, setRoot) => {
            if (!setRoot)
                return path;

            //return `${this.API_URL}${path}`;
            return `${uriBase}${path}`;

        })(path, this.SET_ROOT);

        const fetchHeaders = new Headers();
        if (headers != null)
            for (const key of headers.keys()) {
                let k = headers.get(key)
                if (k != null) {
                    fetchHeaders.append(key, k);
                }
            }

        const fetchOpts: any  = {
            credentials: 'include',
            method: method,
            cache: 'no-store',
            headers: fetchHeaders
        };

        if (!['GET', 'HEAD'].includes(method) && data != null) {
            switch(fetchOpts.headers.get('Content-Type')) {
                case 'application/json':
                    fetchOpts.body = JSON.stringify(data);
                    break;
                case 'application/pdf':
                    fetchOpts.body = data;
                    break;
                default:
                    fetchOpts.body = data;
                    break;
            }
        }

        if (fetchOpts.headers.get('swipesum-origin') == null)
            fetchOpts.headers.set('swipesum-origin', 'portal-prod');

        if (options.authenticate) {
            let authHeader = this.storage.getAuthHeader()

            // if (authHeader == null) {
            //     console.error('We are not authenticated properly. Consider throwing an error or signing out.');
            // }

            fetchOpts.headers.set('Authorization', authHeader);
        }

        //Removing the body and data from the log to avoid logging sensitive data. Add in for debugging purposes.
        Logging.verbose("gateway-api-service", "apiCall", method + "-ing " + url);

        /*
            OK = 200,
            ACCEPTED = 202,
            NO_CONTENT = 204,
            MULTIPLE_CHOICES = 300,
            BAD_REQUEST = 400,
            UNAUTHORIZED = 401,
            PAYMENT_REQUIRED = 402,
            FORBIDDEN = 403,
            NOT_FOUND = 404,
            CONFLICT = 409,
            GONE = 410,
            UNPROCESSABLE = 422,
            INTERNAL_ERROR = 500,
            NOT_IMPLEMENTED = 501
        */

        if (headers.get("content-type") == "application/pdf") {

            return fetch(url, fetchOpts)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.blob();
             })
             .then(blob => {
                const url = window.URL.createObjectURL(blob);

                if (options.returnAsUrl) {
                    return url;
                }
                else {
                    window.open(url);

                    // Optional: For downloading directly instead of opening in a new tab:
                    // const a = document.createElement('a');
                    // a.href = url;
                    // a.download = 'filename.pdf'; // Specify filename here
                    // a.click();
                
                    setTimeout(() => window.URL.revokeObjectURL(url), 100);
                    }

                    return;
         
             })
        }

        if (this.authFailed) {
            // throw new Error("Authentication failed; redirecting to suite sign-in page");
            return;
        }

        let that = this;

        return fetch(url, fetchOpts)
        .then(async (res: Response) => {
            if (res.status === 401) {
                that.authFailed = true;
                // do we want a local error page with a link to the suite sign-in page?
                that.redirectToSuiteSignIn();
            }
            else if (res.status >= 300) {
                // TODO (jacob): 
                throw new Error(`Status code: ${res.status}`);
            }

            const o = await res.json();

            if (o && o.message !== undefined && o.message != "") {
                console.error("error while fetching data", o);
                Logging.verbose("gateway-api-service", "fetch", "error while fetching data", o);
                throw o;
            }
            
            // TODO: This header will may not be present if the request failed on the server side.
            if (options.updateAuthHeader) {
                const authHeader = res.headers.get('Authorization');
                if (authHeader == null) {
                    // If this is a signin request, auth header will be expected but will not be
                    // set if 2-factor auth is required.  In that specific case, we should just
                    // swallow this.
                    console.error('Auth header expected but not found!');
                }
                else {
                    this.storage.setAuthHeader(authHeader);
                }
            }

            return o;
//                return res.json();
        })
        .catch(err => {
            // TODO (jacob): I don't remember why this check is here
            if (!(err instanceof SyntaxError))
                throw err;
        });
    }    



    public async openFile(path:string,
        method: string,
        headers: HttpHeaders,
        params: Record<string, any> | null,
        data: unknown,
        options: any = { setRoot: true, authenticate: true, updateAuthHeader: false })
    {

        //TODO (jacob): this is hacky but I'm in a rush
        if (options == null) 
            options = {};

        if (options.setRoot == null)
            options.setRoot = true;
        if (options.authenticate == null)
            options.authenticate = true;
        if (options.updateAuthHeader == null)
            options.updateAuthHeader = false;

        if (params != null) {
            const tmp = new URLSearchParams();
            for (const key in params as any)
                tmp.append(key,params[key]);

            path = `${path}?${tmp.toString()}`;
        }

        const url = ((path, setRoot) => {
            if (!setRoot)
                return path;

            return `${this.API_URL}${path}`;

        })(path, this.SET_ROOT);

        const fetchHeaders = new Headers();
        if (headers != null)
            for (const key of headers.keys()) {
                let k = headers.get(key)
                if (k != null) {
                    fetchHeaders.append(key, k);
                }
            }

        const fetchOpts: any  = {
            method: method,
            cache: 'no-store',
            headers: fetchHeaders
        };

        if (!['GET', 'HEAD'].includes(method) && data != null) {
            fetchOpts.body = data;
        }

        if (fetchOpts.headers.get('swipesum-origin') == null)
            fetchOpts.headers.set('swipesum-origin', 'portal-prod');

        if (options.authenticate) {
            let authHeader = this.storage.getAuthHeader()

            // if (authHeader == null) {
            //     console.error('We are not authenticated properly. Consider throwing an error or signing out.');
            // }

            fetchOpts.headers.set('Authorization', authHeader);
        }

        Logging.log("gateway-api-service", "openFile", method + "-ing " + url + " with body " + JSON.stringify(fetchOpts.body) + " and data " + JSON.stringify(data));

        return fetch(url, fetchOpts)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.blob();
        })
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            if (options.returnAsUrl) {
                return url;
            }
            else {
                window.open(url);
            
                setTimeout(() => window.URL.revokeObjectURL(url), 100);
                }

                return;
            }
        )

    }    

}
